"use strict";
/**
 * @author Maxim Seredkin
 */
import angular from "angular";
import InvestActivityController from "./controller/invest-activity";
import InvestActivityControllerDescriptionForm from "./controller/invest-activity-description-form";
import InvestActivityControllerEditForm from "./controller/invest-activity-edit-form";
import InvestActivityService from "./service/invest-activity";

export default angular
  .module("investmentProject.invest-activity", [])
  .controller("InvestActivityController", InvestActivityController)
  .controller(
    "InvestActivityControllerDescriptionForm",
    InvestActivityControllerDescriptionForm
  )
  .controller(
    "InvestActivityControllerEditForm",
    InvestActivityControllerEditForm
  )
  .factory("InvestActivityService", InvestActivityService).name;
